import React from 'react'
import LoadingSpinner from 'view/component/loading-spinner'
import Loadable from 'react-loadable'

export default Loadable({
  loader: async () => import('./routes'),
  loading: LoadingSpinner
})
